import { makeStyles } from '@fluentui/react-components';
/** Style docs https://master--628d031b55e942004ac95df1.chromatic.com/?path=/docs/concepts-developer-styling-components--page */
export const useAppHostCommonStyles = makeStyles({
    mediaMaxWidthOverflow: {
        '@media screen and (max-width: 750px)': {
            '&': {
                overflowX: 'scroll',
            },
        },
    },
    displayFlex: {
        display: 'flex',
    },
    flexGrow1: {
        flexGrow: 1,
    },
    flexColumn: {
        flexDirection: 'column',
    },
    heightInherit: {
        height: 'inherit',
    },
    minWidth: {
        minWidth: '735px',
    },
    mainUiContainer: {
        alignSelf: 'center',
        marginBottom: 'auto',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 'auto',
    },
});
//# sourceMappingURL=styles.js.map